// extracted by mini-css-extract-plugin
export default {"carouselWrapper":"_32a699f6","spinner":"_74ec84a8","carouselList":"_73dc55c7","arrowRight":"_74fd654c","arrowLeft":"_ebb18317","swiper":"_ce95685f"};